import Helper from "./Helper";

class Lottie {
  constructor() {
    this.lotties = document.querySelectorAll('lottie-player');
    this.lottiesArray = Array.prototype.slice.call(this.lotties);
    this.classIn = 'is-in-viewport';
    this.classOut = 'is-not-in-viewport';
    this.playedLotties = new Set(); // Track which animations have been played
    this.sequenceDelay = 0; // Shorter delay between animations

    if (this.lotties && this.lotties.length !== 0) {
      this.registerScroll();
      this.bindEvents();
      this.playVisibleAnimations(); // Play animations already in viewport on load
    }
  }

  bindEvents() {
    this.lottiesArray.forEach((item) => {
      if (item.dataset && item.dataset.lottieAccordion === 'true') {
        return;
      }

      if (Helper.isInViewport(item)) {
        Helper.addClass(item, this.classIn);
        Helper.removeClass(item, this.classOut);
      } else {
        Helper.removeClass(item, this.classIn);
        Helper.addClass(item, this.classOut);
      }
    });
  }

  playVisibleAnimations() {
    this.lottiesArray.forEach((item, index) => {
      if (Helper.isInViewport(item) && !this.playedLotties.has(item)) {
        setTimeout(() => {
          if (item && typeof item.play === 'function') {
            try {
              item.play();
              this.playedLotties.add(item);
            } catch (err) {
              // Silently ignore if play fails
            }
          }
        }, index * this.sequenceDelay);
      }
    });
  }

  registerScroll() {
    window.addEventListener("scroll", (e) => {
      this.lottiesArray.forEach((item, index) => {
        if (item.dataset && item.dataset.lottieAccordion === 'true') {
          return;
        }

        this.addClassOnScroll(item);

        if (Helper.hasClass(item, this.classIn) && !this.playedLotties.has(item)) {
          // Play with delay based on index to create natural sequence
          setTimeout(() => {
            // Only attempt to play if the lottie web component API is available
            if (item && typeof item.play === 'function') {
              try {
                item.play();
                this.playedLotties.add(item);
              } catch (err) {
                // Silently ignore if play fails on non-upgraded element
              }
            } else {
              // If the custom element isn't upgraded yet, listen once for readiness
              const tryPlay = () => {
                if (item && typeof item.play === 'function') {
                  try {
                    item.play();
                    this.playedLotties.add(item);
                  } catch (err) {}
                }
              };
              // Some implementations dispatch 'ready' when animation is loaded
              try {
                item.addEventListener('ready', tryPlay, { once: true });
              } catch (err) {
                // No-op: element may not support addEventListener in old states
              }
            }
          }, index * this.sequenceDelay);
        }
      });
    });
  }

  addClassOnScroll(element) {
    if(element.closest('.lc-background-container')) {
      if(Helper.isInViewport(element.closest('.lc-background-container').querySelector('.lc-lottie'))) {
        Helper.addClass(element, this.classIn);
        Helper.removeClass(element, this.classOut);
      }
    } else if (Helper.isInViewport(element)) {
      Helper.addClass(element, this.classIn);
      Helper.removeClass(element, this.classOut);
    } else {
      Helper.addClass(element, this.classOut);
      Helper.removeClass(element, this.classIn);
    }
  }
}

export default Lottie;
